import Vue from 'vue'
import axios from 'axios'
import api from '@/api'
import config from '@/api/config'

import {
    ADD_CATEGORIES,
    ADD_TO_POPULAR_PRODUCTS,
    ADD_TO_PRODUCTS,
    ADD_TO_SEARCH_PRODUCTS,
    CLEAR_SEARCH,
    SET_BLOCK_MODAL_ENABLED,
    SET_BOT_LINK,
    SET_DELIVERY_SERVICES,
    SET_DELIVERY_TIME_MODE,
    SET_FIELD_CUSTOM_FIELDS,
    SET_FIELD_EMAIL,
    SET_FIELD_FULL_ADDRESS,
    SET_FIELD_FULL_NAME,
    SET_FIELD_LOCAL_ADDRESS,
    SET_FIELD_RECIPIENT_PHONE,
    SET_FIELD_MAIN_PHONE,
    SET_FIELD_COMMENT,
    SET_FIELD_ADDRESS,
    SET_FILTER,
    SET_FORCE_GUARD,
    SET_GTM_TAG,
    SET_GUARD_TYPE_ID,
    SET_LINKS,
    SET_LOADING,
    SET_MODAL,
    SET_OUTLET,
    SET_PAYMENT_METHODS,
    SET_POPULAR_PRODUCTS_LOADING,
    SET_PRODUCTS_LOADING,
    SET_SEARCH_CATEGORIES,
    SET_SEARCH_GOT_FIRST,
    SET_SEARCH_QUERY,
    SET_SELECTED_CATEGORY,
    SET_STATUS,
    SET_TIME_SELECTOR,
    SET_TIMES,
    SET_WEBVIEW_GUARD,
    SET_WEBVIEW_SETTINGS,
    SET_REPEAT_ORDER_ID,
    SET_BU_ID,
    SET_OPEN_LIST_MODIFIRE,
    SET_SELECTED_MODIFIRE,
    SET_DELIVERY_FROM_CITY
} from '@/store/mutations.type'
import {
    DISABLE_OVERLAY,
    FETCH_OUTLET,
    FETCH_OUTLET_ADDITIONAL,
    FETCH_PRODUCTS,
    FETCH_SEARCH,
    FETCH_TIMES,
    GET_BASKET,
    SET_GLOBAL_ERROR
} from '@/store/actions.type'


const state = {
    outlet: null,
    deliveryServices: null,
    categories: [],
    products: {},
    filter: {
        date: {
            start: null,
            end: null
        }
    },
    search: {
        query: null,
        gotFirst: false,
        categories: [],
        products: {
            items: [],
            meta: {
                total: null,
                next_page: null,
                loaded: false,
                loading: false
            }
        }
    },
    popularProducts: {
        items: [],
        meta: {
            total: null,
            next_page: null,
            loaded: false,
            loading: false
        }
    },
    selectedCategory: null,
    repeatOrderId: null,
    buId: null,
    openListModifire: null,
    selectedModifire: null
}

const getters = {
    getOpenListModifire(state) {
        return state.openListModifire
    },
    getSelectedModifire(state) {
        return state.selectedModifire
    },
    outlet(state) {
        return state.outlet
    },
    filter(state) {
        return state.filter
    },
    products(state) {
        return state.products
    },
    popularProducts(state) {
        return state.popularProducts
    },
    categories(state) {
        return state.categories
    },
    search(state) {
        return state.search
    },
    selectedCategory(state) {
        return state.selectedCategory
    },
    outletSettings(state) {
        return state.outlet ? state.outlet.outlet_settings : null
    },
    canPerformOrder(state) {
        if (!state.outlet) {
            return false
        }
        const hasAvailableDays = (state.outlet.outlet_settings.delivery_time.hasOwnProperty('days') && Object.values(state.outlet.outlet_settings.delivery_time.days).some(day => (day.length > 0)))
        return state.outlet.outlet_settings.delivery_time.today.length !== 0 || state.outlet.outlet_settings.delivery_time.tomorrow.length !== 0 || hasAvailableDays
    },
    deliveryServices(state) {
        return state.deliveryServices
    },
    country(state) {
        return state.outlet.outlet.country
    }
}

export const actions = {

    [FETCH_TIMES](context) {
        return axios({
            method: 'POST',
            url: api.outlet.getTimes.url()
        }).then(response => {
            context.commit(SET_TIMES, response.data)
            return response.data
        })
    },

    [FETCH_OUTLET](context, params) {
        axios({
            method: 'POST',
            url: api.outlet.getOutlet.url({}, { version: config.version3 })
        }).then(async response => {
            if (token !== 'store' || token !== 'guard') {
                context.dispatch(DISABLE_OVERLAY)
            }
            if (context.getters.token === process.env.VUE_APP_WEB_TOKEN) {
                context.dispatch(FETCH_OUTLET_ADDITIONAL).then(() => {
                    context.dispatch(GET_BASKET)
                })
            }
            if (response.data.webview_settings) {
                if ((
                        ((response.data.outlet_settings.delivery_type === 3 ) && (
                            response.data.webview_settings.enabled_address_webview ||
                            (response.data.webview_settings.hasDistricts && !response.data.outlet_settings.company_use_kml)
                        )) ||
                        ((response.data.outlet_settings.delivery_type === 1 || response.data.outlet_settings.delivery_type === 2) && (
                            response.data.webview_settings.select_outlet_on_webview ||
                            response.data.webview_settings.show_choose_outlets_always
                        )) || 
                        ((response.data.outlet_settings.delivery_type === 4) && (
                            response.data.webview_settings.select_outlet_on_webview ||
                            response.data.webview_settings.show_choose_outlets_always
                        ) && context.getters.guardOutlets.length > 1 ) 

                    ) && !context.getters.guardPass) {
                    await context.commit(SET_FORCE_GUARD, true)
                    await context.commit(SET_GUARD_TYPE_ID, response.data.outlet_settings.delivery_type)
                    return context.commit(SET_WEBVIEW_GUARD, true)
                }
                context.commit(SET_WEBVIEW_SETTINGS, response.data.webview_settings)
                context.commit(SET_GTM_TAG, response.data.webview_settings.gtmTag)

                if (response.data.webview_settings.blockModalEnabled) {
                    context.commit(SET_BLOCK_MODAL_ENABLED, response.data.webview_settings.blockModalEnabled)
                    context.commit(SET_MODAL, { modal: 'block', status: true })
                    document.body.classList.add('overflow')
                }

                context.commit(SET_DELIVERY_TIME_MODE, response.data.webview_settings.deliveryTimeMode)
                context.commit(SET_TIME_SELECTOR, response.data.webview_settings.timeSelector)
                context.commit(SET_FIELD_EMAIL, response.data.webview_settings.formEmail)
                context.commit(SET_FIELD_CUSTOM_FIELDS, response.data.webview_settings.formCustomFields)
                context.commit(SET_FIELD_FULL_ADDRESS, response.data.webview_settings.formFullAddress)
                context.commit(SET_FIELD_FULL_NAME, response.data.webview_settings.formFullName)
                context.commit(SET_FIELD_LOCAL_ADDRESS, response.data.webview_settings.formLocalAddress)
                context.commit(SET_FIELD_RECIPIENT_PHONE, response.data.webview_settings.formRecipientPhone)
                context.commit(SET_FIELD_MAIN_PHONE, response.data.webview_settings.formMainPhone)
                context.commit(SET_FIELD_COMMENT, response.data.webview_settings.formShowComment)
                context.commit(SET_FIELD_ADDRESS, response.data.webview_settings.formOutletAddress)
            }
            if (response.data.city) {
                context.commit(SET_DELIVERY_FROM_CITY, response.data.city)
            }
            context.commit(SET_OUTLET, response.data)

            if (context.getters.outlet.outlet.acceptance_18_plus) {
                context.commit(SET_MODAL, { modal: 'block', status: true })
            }

            if (response.data.products) {
                context.commit(ADD_TO_POPULAR_PRODUCTS, { pagination: response.data.products })
            }

            if (context.state.categories.length === 0) {
                if (context.getters.outletSettings.delivery_type !== 4) {
                    context.commit(ADD_CATEGORIES, [{ id: 0, name: null, 'level': null }])
                }
                context.commit(ADD_CATEGORIES, [{ id: null, name: new Vue().text('all_categories'), 'level': 0 }])
            }
            if (context.getters.outletSettings.delivery_type !== 4) {
                context.commit(ADD_CATEGORIES, response.data.products_categories)
            } else {
                context.commit(ADD_CATEGORIES, response.data.resources_categories)
            }
            if (context.getters.overlay === true) {
                context.dispatch(DISABLE_OVERLAY)
            }

        }).catch(error => {
            if (error.response && error.response.data && error.response.data.bot_link) {
                // if same host
                if (error.response.data.bot_link.indexOf(window.location.host) !== -1) {
                    window.location.hash = error.response.data.bot_link.substr(
                        error.response.data.bot_link.indexOf('#'))
                    window.location.reload()
                } else {
                    window.location = error.response.data.bot_link
                }
            }
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    },

    async [FETCH_OUTLET_ADDITIONAL](context) {
        return await axios({
            method: 'POST',
            url: api.outlet.getOutletAdditional.url({}, { version: config.version3 })
        }).then(async response => {
            if (context.rootState.settings.contactlessMode && !context.rootState.settings.enable_online_payment) {
                const result = response.data.payment_methods.filter(payment => payment.id === 4)
                context.commit(SET_PAYMENT_METHODS, result)
            } else {
                context.commit(SET_PAYMENT_METHODS, response.data.payment_methods)
            }
            context.commit(SET_DELIVERY_SERVICES, response.data.delivery_services)

            context.commit(SET_STATUS, { process: FETCH_OUTLET_ADDITIONAL, status: true })

        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
            throw new Error("Additional outlet error");
        })
    },

    async [FETCH_SEARCH](context, params) {
        if (context.getters.search.query !== params.query) {
            await context.commit(SET_SEARCH_GOT_FIRST, false)
            return
        }
        await context.commit(SET_LOADING, { process: FETCH_SEARCH, loading: true })

        return await axios({
            method: 'POST',
            data: params,
            url: context.getters.outletSettings.delivery_type !== 4 ? api.product.search.url() : api.resource.search.url()
        }).then(async response => {
            if (context.getters.search.query === params.query) {
                if (response.data.categories) {
                    await context.commit(SET_SEARCH_CATEGORIES, response.data.categories)
                }
                await context.commit(ADD_TO_SEARCH_PRODUCTS, { pagination: response.data.products })
                await context.commit(SET_SEARCH_GOT_FIRST, true)
            }
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        }).finally(() => {
            context.commit(SET_LOADING, { process: FETCH_SEARCH, loading: false })
        })
    },

    async [FETCH_PRODUCTS](context, params) {
        await context.commit(SET_LOADING, { process: FETCH_PRODUCTS, loading: true })

        let url

        if (params.category_id !== 0) {
            url = context.getters.outletSettings.delivery_type !== 4 ? api.category.getProducts.url() : api.resourceCategory.getResources.url()
            await context.commit(SET_PRODUCTS_LOADING, { loading: true, categoryId: params.category_id })
        } else {
            url = api.product.getPopularProducts.url()
            await context.commit(SET_POPULAR_PRODUCTS_LOADING, { loading: true, categoryId: params.category_id })
        }

        return await axios({
            method: 'POST',
            data: params,
            url: url
        }).then(async response => {
            if (params.category_id !== 0) {
                await context.commit(ADD_TO_PRODUCTS, { pagination: response.data, categoryId: params.category_id })
            } else {
                await context.commit(ADD_TO_POPULAR_PRODUCTS, { pagination: response.data })
            }
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        }).finally(() => {
            if (params.category_id !== 0) {
                context.commit(SET_PRODUCTS_LOADING, { loading: false, categoryId: params.category_id })
            } else {
                context.commit(SET_POPULAR_PRODUCTS_LOADING, { loading: false, categoryId: params.category_id })
            }
            context.commit(SET_LOADING, { process: FETCH_PRODUCTS, loading: false })
        })
    }
}

export const mutations = {
    [SET_SELECTED_MODIFIRE](state, value) {
        state.selectedModifire = value
    },
    [SET_OPEN_LIST_MODIFIRE](state, value) {
        state.openListModifire = value
    },
    [SET_BU_ID](state, data) {
        state.buId = data
    },

    [SET_REPEAT_ORDER_ID](state, data) {
        state.repeatOrderId = data
    },

    [SET_SELECTED_CATEGORY](state, data) {
        state.selectedCategory = data
    },

    [SET_DELIVERY_SERVICES](state, data) {
        state.deliveryServices = data
    },

    [SET_BOT_LINK](state, data) {
        state.outlet.outlet_settings.bot_link = data
    },

    [SET_OUTLET](state, data) {
        state.outlet = data
        document.title = data.outlet.company
    },

    [SET_TIMES](state, data) {
        state.outlet.outlet_settings.delivery_time = data
    },

    [ADD_TO_POPULAR_PRODUCTS](state, data) {
        let pagination = data.pagination

        if (state.popularProducts.meta.loaded) {
            return
        }

        state.popularProducts.meta.total = pagination.total
        if (pagination.next_page === null || state.popularProducts.meta.next_page < pagination.next_page) {
            state.popularProducts.meta.next_page = pagination.next_page
        }
        if (pagination.next_page === null) {
            state.popularProducts.meta.loaded = true
        }

        for (let i = 0; i < pagination.items.length; i++) {
            const product = pagination.items[i]
            let add = true
            for (let j = 0; j < state.popularProducts.items.length; j++) {
                const addedProduct = state.popularProducts.items[j]

                if (product.id === addedProduct.id) {
                    add = false
                }
            }

            if (add) {
                state.popularProducts.items.push(product)
            }
        }
    },

    [ADD_TO_SEARCH_PRODUCTS](state, data) {
        let pagination = data.pagination

        if (state.search.products.meta.loaded) {
            return
        }

        state.search.products.meta.total = pagination.total
        if (pagination.next_page === null || state.search.products.meta.next_page < pagination.next_page) {
            state.search.products.meta.next_page = pagination.next_page
        }
        if (pagination.next_page === null) {
            state.search.products.meta.loaded = true
        }

        for (let i = 0; i < pagination.items.length; i++) {
            const product = pagination.items[i]
            let add = true
            for (let j = 0; j < state.search.products.items.length; j++) {
                const addedProduct = state.search.products.items[j]

                if (product.id === addedProduct.id) {
                    add = false
                }
            }

            if (add) {
                state.search.products.items.push(product)
            }
        }
    },

    [ADD_TO_PRODUCTS](state, data) {
        let pagination = data.pagination
        let categoryId = data.categoryId

        if (state.products[categoryId].meta.loaded) {
            return
        }

        state.products[categoryId].meta.total = pagination.total
        if (pagination.next_page === null || state.products[categoryId].meta.next_page < pagination.next_page) {
            state.products[categoryId].meta.next_page = pagination.next_page
        }
        if (pagination.next_page === null) {
            state.products[categoryId].meta.loaded = true
        }

        for (let i = 0; i < pagination.items.length; i++) {
            const product = pagination.items[i]
            let add = true
            for (let j = 0; j < state.products[product.category_id].items.length; j++) {
                const addedProduct = state.products[product.category_id].items[j]

                if (product.id === addedProduct.id) {
                    add = false
                }
            }

            if (add) {
                state.products[product.category_id].items.push(product)
            }
        }
    },

    [SET_PRODUCTS_LOADING](state, data) {
        state.products[data.categoryId].meta.loading = data.loading
    },

    [SET_POPULAR_PRODUCTS_LOADING](state, data) {
        state.popularProducts.meta.loading = data.loading
    },

    [ADD_CATEGORIES](state, data) {
        data.sort((a, b) => (a.is_not_deleted > b.is_not_deleted) ? 1 : ((b.is_not_deleted > a.is_not_deleted) ? -1 : 0))
        for (let key in data) {
            state.categories.push(data[key])
            Vue.set(state.products, data[key].id, {
                meta: {
                    total: null,
                    next_page: null,
                    loaded: false,
                    loading: false
                },
                items: []
            })
        }
    },

    [SET_SEARCH_CATEGORIES](state, data) {
        state.search.categories = []
        for (let i in data) {
            for (let j in state.categories) {
                if (data[i].id === state.categories[j].id) {
                    state.search.categories.push(state.categories[j])
                    break
                }
            }
        }
    },

    [SET_SEARCH_QUERY](state, data) {
        state.search.query = data
    },

    [SET_SEARCH_GOT_FIRST](state, data) {
        state.search.gotFirst = data
    },

    [SET_FILTER](state, { filter, data }) {
        state.filter[filter] = data
    },

    [CLEAR_SEARCH](state) {
        state.search = {
            query: null,
            gotFirst: false,
            categories: [],
            products: {
                items: [],
                meta: {
                    total: null,
                    next_page: null,
                    loaded: false,
                    loading: false
                }
            }
        }
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}